import styled from 'styled-components';

export const NewHomePageWrapper = styled.div`
  font-family: 'Montserrat';

  .header {
    position: relative;
    z-index: 99;
    background-color: rgba(255, 255, 255, 1);

    margin-bottom: -88px;
  }
`;

export const Container = styled.main`
  width: 100vw;
  height: fit-content;
  min-height: 100vh;

  font-family: 'Montserrat';
`;
